import styled from "styled-components";
import { useEffect, useRef } from "react";
import { useQrScanner } from "../../hooks/useQrScanner";
import { Button } from "../atoms/Button";
import { useEvent } from "../../contexts/EventContext";
import { useUnlockAudio } from "../../hooks/useUnlockAudio";

const Panel = styled.section`
  display: grid;
  gap: 12px;
`;

const Row = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
`;

const ErrorRow = styled(Row)`
  padding: 12px;
  border-radius: 12px;
  background: #ffffff;
  color: #CF000E;
  font-size: 14px;
`;

const Reader = styled.div`
  // width: min(420px, 100%);
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  border-radius: 12px;
  border: 2px solid ${props => props.$active ? "#DE644E" : "transparent"};
  overflow: hidden;
  background: #ffffff;
  // padding: ${(props) => (props.$active ? "8px" : "0")};
  padding: 0;
  box-shadow: ${props => props.$active ? "0 0 0 3px rgba(59, 130, 246, 0.2)" : "none"};
  transition: all 0.2s;
`;

export function QrScannerPanel({ onDetected, parseError, processing, }) {
  // ブラウザで音を出せるようにする
  useUnlockAudio();

  const { status, result, error, start, stop } = useQrScanner({
    readerId: "reader",
    stopAfterScan: true, // 1回読んだら止める（受付用途で分かりやすい）
  });

  // イベントが選択されているかを確認する用
  const { selectedEvent } = useEvent();
  const isEventSelected = !!selectedEvent;

  useEffect(() => {
    if (!result) return;

    console.log("[QrScannerPanel] detected:", result);

    onDetected?.(result);
  }, [result, onDetected]);

  // イベントが選択されていなかったら強制停止
  useEffect(() => {
    if (!isEventSelected && status === "scanning") {
      stop();
    }
  }, [isEventSelected, status, stop]);


  return (
    <Panel>
      <Row>
        <Button
          variant={status === "scanning" ? "ghost" : "primary"}
          size="xl"
          fullWidth
          onClick={status === "scanning" ? stop : start}
          disabled={!isEventSelected || processing}
        >
          {
            processing
            ? "処理中..."
            : status === "scanning"
            ? "読み取り停止"
            : "読み取り開始"
          }
        </Button>
      </Row>

      {error && (
        <ErrorRow>
          エラー: {error}
        </ErrorRow>
      )}
      
      {parseError && (
        <ErrorRow>
          {parseError}
        </ErrorRow>
      )}

      {/* html5-qrcode がここにカメラ映像を描画する */}
      <Reader id="reader" $active={status === "scanning"} />
    </Panel>
  );
}
